const isOpen = ref(false)

const open = () => {
  isOpen.value = true
}

const close = () => {
  isOpen.value = false
}

export const useShoppingCartDrawer = () => ({
  isOpen: readonly(isOpen),
  open,
  close,
})
